import React, {Component} from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import {FaCloud} from "react-icons/fa";
import {Card, CardBody, Input, Label} from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import Select from "react-select";
import InputSpinner from "react-bootstrap-input-spinner";

class AdminDetailVpsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            vps: [],
            listUser: [],
            listProduct: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            errorForm: false,
            messageForm: '',
            success: false,
            messageSuccess: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            userId: 0,
            typeOrder: '',
            user_id: 0,
            product_id: 0,
            selected_user: 0,
            selected_product: 0,
            selected_status: 0,
            check_amount: false,
            amount: '0',
            ip: '',
            username: '',
            password: '',
            addon_cpu: '',
            addon_ram: '',
            addon_disk: '',
            changeCheckAmount: '',
            listStatusVps: [],
            statusVps: '',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        this.getDetailService( this.props.vpsId );

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getDetailService = (vpsId) => {
        this.setState({
            loadPage: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/vps/detailVps/' + vpsId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data.vps);
                if ( ref.data.error === 0 ) {
                    let selected_user = 0;
                    let selected_product = 0;
                    let selected_status = 0;
                    //user
                    ref.data.listUser.forEach( (user, key) => {
                        if ( user.value === ref.data.vps.user_id ) {
                            selected_user = key;
                        }
                    })
                    //product
                    ref.data.listProduct.forEach( (product, key) => {
                        if ( product.value === ref.data.vps.product_id ) {
                            selected_product = key;
                        }
                    })
                    // status vps
                    ref.data.listStatusVps.forEach( (status, key) => {
                        if ( status.value === ref.data.vps.status_vps ) {
                            selected_status = key;
                        }
                    })

                    this.setState({
                        vps: ref.data.vps,
                        user_id: ref.data.vps.user_id,
                        product_id: ref.data.vps.product_id,
                        statusVps: ref.data.vps.status_vps,
                        check_amount: ref.data.vps.check_amount,
                        amount: ref.data.vps.amount_vps,
                        ip: ref.data.vps.ip,
                        username: ref.data.vps.username,
                        password: ref.data.vps.password,
                        addon_cpu: ref.data.vps.addon_cpu,
                        addon_ram: ref.data.vps.addon_ram,
                        addon_disk: ref.data.vps.addon_disk,
                        changeCheckAmount: ref.data.vps.changeCheckAmount,
                        listUser: ref.data.listUser,
                        listProduct: ref.data.listProduct,
                        listStatusVps: ref.data.listStatusVps,
                        loadPage: false,
                        isLoading: false,
                        selected_user: selected_user,
                        selected_product: selected_product,
                        selected_status: selected_status,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu dịch vụ thất bại',
                })
            })
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    changeUserAdd = async selectedOption => {
        let user_id = selectedOption.value;
        this.setState({
            isLoading: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/vps/loadProductByUser/' + user_id,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        product_id: 0,
                        selected_product: '',
                        user_id: user_id,
                        listProduct: ref.data.listProduct,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu dịch vụ thất bại',
                })
            })
    }

    changeProduct = (event) => {
        this.setState({
            [event.target.name] : event.target.type === 'checkbox' ? event.target.checked : event.target.value
        })
    }

    changeAddonCpu = (num) => {
        this.setState({
            addon_cpu: num
        })
    }

    changeAddonRam = (num) => {
        this.setState({
            addon_ram: num
        })
    }

    changeAddonDisk = (num) => {
        this.setState({
            addon_disk: num
        })
    }

    changeStatus = selectedOption => {
        let choosse = selectedOption.value;
        this.setState({
            statusVps: choosse
        })
    }

    submit = () => {

        if ( this.validate() ) {
            this.setState({
                loadPage: true
            })

            let form = {
                vpsId: this.props.vpsId,
                user_id: this.state.user_id,
                product_id: this.state.product_id,
                statusVps: this.state.statusVps,
                ip: this.state.ip,
                username: this.state.username,
                password: this.state.password,
                addon_cpu: this.state.addon_cpu,
                addon_ram: this.state.addon_ram,
                addon_disk: this.state.addon_disk,
                check_amount: this.state.check_amount,
                amount: this.state.amount,
            }
            // console.log(form);
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };

            axios.put( process.env.REACT_APP_API_URL + '/api/admin/vps/editVps', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        this.setState({
                            success: true,
                            messageSuccess: ref.data.message,
                            loadPage: false,
                        })
                        this.getDetailService( this.props.vpsId );
                    } else {
                        if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                            this.props.logOut();
                        } else {
                            this.setState({
                                error: true,
                                messageError: ref.data.message,
                                loadPage: false,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        loadPage: false,
                        isLoading: false,
                        error: true,
                        messageError: 'Chỉnh sửa dịch vụ thất bại',
                    })
                })
        }

    }

    validate = () => {
        if ( !this.state.user_id ) {
            this.setState({
                errorForm: false,
                messageForm: 'Khách hàng không được để trống'
            })
            return false;
        }
        else if ( !this.state.product_id ) {
            this.setState({
                errorForm: false,
                messageForm: 'Sản phẩm không được để trống'
            })
            return false;
        }
        else if ( !this.state.statusVps.length ) {
            this.setState({
                errorForm: false,
                messageForm: 'Trạng thái không được để trống'
            })
            return false;
        }
        return true;
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Chi tiết VPS"} page={"VPS"}
                                        icon={<FaCloud className="breadcrumb-icon"/>}/>
                            <Card>
                                <CardBody>
                                    <div className="container">
                                        <div className="row">
                                            {
                                                this.state.error ? (
                                                    <div className="col-md-12">
                                                        <Alert color="danger">
                                                            { this.state.messageError }
                                                        </Alert>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {
                                                            this.state.errorForm ? (
                                                                <div className="col-md-12">
                                                                    <Alert color="danger">
                                                                        { this.state.messageErrorForm }
                                                                    </Alert>
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                        {
                                                            this.state.success ? (
                                                                <div className="col-md-12">
                                                                    <Alert color="success">
                                                                        { this.state.messageSuccess }
                                                                    </Alert>
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                        <div className="col-md-6 pr-2">
                                                            <div className="order">
                                                                <div className="detail_order">
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label for="user">Khách hàng</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <Select
                                                                                onChange={this.changeUserAdd}
                                                                                classNamePrefix="select"
                                                                                className="basic-single"
                                                                                placeholder={'Chọn khách hàng'}
                                                                                defaultValue={ this.state.listUser[ this.state.selected_user ] }
                                                                                id="user"
                                                                                options={this.state.listUser}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label for="product">Sản phẩm</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <select name="product_id" id="product_id"
                                                                                    onChange={this.changeProduct}
                                                                                    className="form-control"
                                                                                    value={ this.state.product_id }
                                                                            >
                                                                                <option value="0" disabled={true}>Chọn sản phẩm</option>
                                                                                {
                                                                                    this.state.listProduct.length ? (
                                                                                        this.state.listProduct.map( (product, key) => (
                                                                                            <option value={ product.value } key={key}>{ product.label }</option>
                                                                                        ))
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label for="ip">IP</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <Input
                                                                                type="text"
                                                                                className="form-control" id="ip" name="ip"
                                                                                defaultValue={ this.state.vps.ip }
                                                                                onChange={this.changeInput}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label for="username">Tài khoản</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <Input
                                                                                type="text"
                                                                                className="form-control" id="username" name="username"
                                                                                defaultValue={ this.state.vps.username }
                                                                                onChange={this.changeInput}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label for="password">Mật khẩu</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <Input
                                                                                type="text"
                                                                                className="form-control" id="password" name="password"
                                                                                defaultValue={ this.state.vps.password }
                                                                                onChange={this.changeInput}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label>Cấu hình</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <b>{ this.state.vps.text_config }</b>
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label for="addon_cpu">Addon CPU</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <InputSpinner
                                                                                type={'int'}
                                                                                precision={2}
                                                                                max={20}
                                                                                min={0}
                                                                                step={1}
                                                                                value={ this.state.vps.addon_cpu }
                                                                                onChange={ (num) =>  this.changeAddonCpu(num) }
                                                                                variant={'dark'}
                                                                                id="addon_cpu"
                                                                                // size="sm"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label for="addon_ram">Addon RAM</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <InputSpinner
                                                                                type={'int'}
                                                                                precision={2}
                                                                                max={20}
                                                                                min={0}
                                                                                step={1}
                                                                                value={ this.state.vps.addon_ram }
                                                                                onChange={ (num) =>  this.changeAddonRam(num) }
                                                                                variant={'dark'}
                                                                                id="addon_ram"
                                                                                // size="sm"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label for="addon_disk">Addon DISK</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <InputSpinner
                                                                                type={'int'}
                                                                                precision={2}
                                                                                max={200}
                                                                                min={0}
                                                                                step={10}
                                                                                value={ this.state.vps.addon_disk }
                                                                                onChange={ (num) =>  this.changeAddonDisk(num) }
                                                                                variant={'dark'}
                                                                                id="addon_disk"
                                                                                // size="sm"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 pl-2">
                                                            <div className="order">
                                                                <div className="detail_order">
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label for="status">Trạng thái</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <Select
                                                                                options={this.state.listStatusVps}
                                                                                onChange={this.changeStatus}
                                                                                classNamePrefix="select"
                                                                                placeholder={'Chọn trạng thái'}
                                                                                defaultValue={ this.state.listStatusVps[ this.state.selected_status ] }
                                                                                id="status"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label>Ngày đặt hàng</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            { this.state.vps.text_create_date }
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label>Ngày tạo</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            { this.state.vps.text_date_create }
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label>Ngày hết hạn</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            { this.state.vps.text_next_due_date }
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label>Thời gian thuê</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            { this.state.vps.text_billing_cycle }
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label>Giá áp tay</Label>
                                                                        </div>
                                                                        <div className="col-md-8 text-left">
                                                                            <input type="checkbox" value="1"
                                                                                   defaultChecked={ this.state.vps.check_amount }
                                                                                   onChange={ this.changeInput }
                                                                                   name="check_amount"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-4 text-right">
                                                                            <Label>Chi phí</Label>
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            {
                                                                                !this.state.check_amount ? (
                                                                                    <>
                                                                                        { this.state.vps.text_amount } ₫
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <input type="text" className="form-control"
                                                                                               name="amount"
                                                                                               defaultValue={ this.state.vps.amount_vps }
                                                                                               onChange={this.changeInput}
                                                                                        />
                                                                                    </>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group text-right mt-4 mr-4">
                                                                        <button type="button" className="btn btn-primary" onClick={ () => this.submit() }>
                                                                            Cập nhật VPS
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminDetailVps' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminDetailVpsComponent);